import { motion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines = [], className = "", lineClassName = "", delay = 0 }) => (
  <div className={className}>
    {lines.map((line, i) => (
      <div key={i} className="overflow-hidden py-[0.06em]">
        <motion.div
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, delay: delay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
          className={lineClassName}
        >
          {line}
        </motion.div>
      </div>
    ))}
  </div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-gold/70" />
    <span className="text-[11px] sm:text-xs tracking-[0.3em] uppercase text-gold font-semibold">{children}</span>
  </div>
);

export const PageHero = ({ eyebrow, lines, sub, testid }) => (
  <section className="relative overflow-hidden pt-32 pb-12 lg:pt-44 lg:pb-16 grain" data-testid={testid}>
    <div className="pointer-events-none absolute -top-40 left-1/2 h-[480px] w-[720px] -translate-x-1/2 rounded-full bg-gold/[0.05] blur-[120px]" />
    <div className="relative mx-auto max-w-7xl px-6">
      <FadeUp>
        <Eyebrow>{eyebrow}</Eyebrow>
      </FadeUp>
      <MaskedLines
        className="mt-6"
        delay={0.15}
        lineClassName="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#F5F3EE] tracking-tight"
        lines={lines}
      />
      {sub && (
        <FadeUp delay={0.45} className="mt-6 max-w-2xl">
          <p className="text-base sm:text-lg text-[#969696] leading-relaxed">{sub}</p>
        </FadeUp>
      )}
    </div>
  </section>
);
